module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title":"리뷰 정렬 기준"}}')
  delete Component.options._Ctor
}
